import React, { useState, useEffect, useMemo } from 'react';
import { Drawer, Form, Button, message, Input, Table } from 'antd';
import apis from './apis';
import SwitchTab from '@/pages/activity-manage/merchants/detail/components/my-product-list/components/SwitchTab';
import './index.less';
// 文件类型 1：skuid   2： 店铺id   3：类目id   5：三级类目   7：三级类目id*商家id   8：商家id（venderID）
type fileType = 1 | 2 | 3 | 8;
enum fileTypeEnum {
  SKUID = 1,
  SHOPID = 2,
  CLASSID = 3,
  VENDERID = 8,
}
const idTitle = {
  1: 'SKU ID',
  2: '店铺ID',
  3: '三级类目ID',
  8: '商家ID',
};
const getTabData = () =>
  [
    {
      localName: <span>SKU ID</span>,
      name: <span style={{ display: 'inline-block' }}>SKU ID</span>,
      key: fileTypeEnum.SKUID,
      left: 3,
      index: 1,
    },
    {
      localName: <span>类目</span>,
      name: <span style={{ display: 'inline-block' }}>类目</span>,
      key: fileTypeEnum.CLASSID,
      left: 105,
      index: 2,
    },
    {
      localName: <span>商家ID</span>,
      name: <span style={{ display: 'inline-block' }}>商家ID</span>,
      key: fileTypeEnum.VENDERID,
      left: 105,
      index: 2,
    },
  ] as { localName: any; name: any; key: fileType; left: number; index: number }[];

const WhiteList: React.FC = () => {
  const [data, setData] = useState<any>({});
  const [dataSource, setDataSource] = useState<any>({});
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(true);
  const [searchParams, setSearchParams] = useState<any>({ currentPage: 1, pageSize: 10 });
  const [activeKey, setActiveKey] = useState<fileType>(fileTypeEnum.SKUID);
  const [switchTab] = useState(getTabData()[0]);
  const [deleteBtnDisabled, setDeleteBtnDisabled] = useState(true);
  const [form] = Form.useForm();

  useEffect(() => {
    window.ACORE = window.ACORE || {};
    (window.ACORE as any).openWhiteList = ({ sceneCode, planCode }: any) => {
      setData({ sceneCode, planCode });
      setVisible(true);
    };
  }, []);

  useEffect(() => {
    if (!visible) {
      // 弹窗关闭后所有查询参数重置
      setActiveKey(fileTypeEnum.SKUID);
      setSearchParams({ currentPage: 1, pageSize: 10 });
      form.resetFields();
      return;
    }
    getBtnStatus();
  }, [visible]);

  useEffect(() => {
    if (!visible) return;
    let didMount = true;
    setDataSource({});
    setLoading(true);
    apis
      .listWhiteBlackItem({
        ...data,
        ...searchParams,
        type: 10,
        fileType: activeKey,
      })
      .then((res) => {
        if (!didMount) return;
        const { ret } = res;
        if (ret && ret === '0' && res.data) {
          setDataSource(res.data);
        } else {
          message.error(res.msg);
        }
      })
      .catch((err) => {
        message.error(err);
      })
      .finally(() => setLoading(false));
    return () => {
      didMount = false;
    };
  }, [activeKey, visible, searchParams, data]);

  function getBtnStatus() {
    apis
      .isWhiteBlackItem({ ...data, type: 10 })
      .then((res) => {
        const { ret, msg } = res;
        if (ret !== '0' || !res.data) throw msg || '黑白名单数据信息请求失败';
        setDeleteBtnDisabled(!res.data.isBlackAndWhite);
      })
      .catch((err) => {
        message.error(err);
      });
  }

  function search() {
    setSearchParams({ ...searchParams, currentPage: 1, ...form.getFieldsValue() });
  }

  function onChange(e: any) {
    form.resetFields();
    setActiveKey(e);
    search();
  }

  function reset(e: any) {
    form.resetFields();
    search();
  }

  function handelCloseUpload() {
    //上传文件后的操作：更新列表，更新剔白按钮状态
    search();
    getBtnStatus();
  }

  const columns = useMemo(() => {
    return [
      {
        title: idTitle[activeKey],
        dataIndex: 'value',
        key: 'value',
      },
      {
        title: activeKey === fileTypeEnum.SHOPID ? '店铺名称' : '商家名称',
        dataIndex: 'storeName',
        key: 'storeName',
      },
      {
        title: '一级类目',
        dataIndex: 'valueName1',
        key: 'valueName1',
        render(_: any, record: any) {
          const { valueName1, value1 } = record;
          return (
            <>
              <div>{valueName1}</div>
              <div>ID: {value1}</div>
            </>
          );
        },
      },
      {
        title: '二级类目',
        dataIndex: 'valueName2',
        key: 'valueName2',
        render(_: any, record: any) {
          const { valueName2, value2 } = record;
          return (
            <>
              <div>{valueName2}</div>
              <div>ID: {value2}</div>
            </>
          );
        },
      },
      {
        title: '三级类目',
        dataIndex: 'valueName3',
        key: 'valueName3',
        render(_: any, record: any) {
          const { valueName3, value3 } = record;
          return (
            <>
              <div>{valueName3}</div>
              <div>ID: {value3}</div>
            </>
          );
        },
      },
      {
        title: '商家/采销信息',
        dataIndex: 'identityCode',
        key: 'identityCode',
        render(identityCode: string, { identityName }: any) {
          return (
            <div>
              <div>{identityName}</div>
              <div>{identityCode}</div>
            </div>
          );
        },
      },
      {
        title: '操作人erp',
        dataIndex: 'creator',
      },
      {
        title: '状态',
        dataIndex: 'deleted',
        key: 'deleted',
        render(deleted: number) {
          return <span className="status-text">{deleted === 0 ? '加白成功' : '删白成功'}</span>;
        },
      },
    ].filter((item) => {
      let show = true;
      switch (item.key) {
        case 'value':
          show = [fileTypeEnum.SHOPID, fileTypeEnum.VENDERID, fileTypeEnum.SKUID].includes(activeKey as any);
          break;
        case 'identityCode':
          show = [fileTypeEnum.SKUID].includes(activeKey as any);
          break;
        case 'storeName':
          show = [fileTypeEnum.SHOPID, fileTypeEnum.VENDERID].includes(activeKey as any);
          break;
        case 'valueName1':
        case 'valueName2':
        case 'valueName3':
          show = [fileTypeEnum.SKUID, fileTypeEnum.CLASSID].includes(activeKey as any);
          break;
        default:
          break;
      }
      return show;
    });
  }, [activeKey]);

  return (
    <Drawer
      title={
        <>
          价格校验白名单
          <span style={{ fontSize: '12px' }}>
            &nbsp;&nbsp;白名单商品不参与活动期间的定时价格校验。删除白名单后恢复则恢复价格校验。
          </span>
        </>
      }
      visible={visible}
      width={1200}
      destroyOnClose
      onClose={() => {
        setVisible(false);
      }}
      footer={null}
    >
      <div className="price-check-white-list">
        <div className="header-tab-wrapper">
          <SwitchTab tab={switchTab} getTabData={getTabData} onChange={onChange} showNum={false} />
          <div>
            <Button
              onClick={() =>
                (window.ACORE as any)?.openWhiteUpload({ ...data, type: 10, handelCloseUpload: handelCloseUpload })
              }
              className="set-btn"
              shape="round"
            >
              设置白名单
            </Button>
            <Button
              disabled={deleteBtnDisabled}
              onClick={() =>
                (window.ACORE as any)?.openWhiteUpload({ ...data, type: 22, handelCloseUpload: handelCloseUpload })
              }
              className="set-btn"
              shape="round"
            >
              剔除白名单
            </Button>
          </div>
        </div>
        <Form layout="inline" form={form} initialValues={{}}>
          <Form.Item name="value" label={idTitle[activeKey]}>
            <Input placeholder="请输入" />
          </Form.Item>
          <Form.Item>
            <Button onClick={search} ghost className="set-btn" type="primary">
              查询
            </Button>
            <Button onClick={reset} className="set-btn">
              重置
            </Button>
          </Form.Item>
        </Form>
        <Table
          pagination={{
            showSizeChanger: true,
            current: searchParams.currentPage,
            pageSize: searchParams.pageSize,
            total: dataSource.totalCount,
            onChange(currentPage, pageSize) {
              setSearchParams({ ...searchParams, currentPage, pageSize });
            },
          }}
          loading={loading}
          style={{ margin: '8px 0' }}
          dataSource={dataSource.list}
          columns={columns}
        />
      </div>
    </Drawer>
  );
};
export default WhiteList;
